import RiskModelDetailView from './RiskModelDetailView';
import RiskModelListView from './RiskModelListView';

const views = {
  RiskModelListView,
  RiskModelDetailView,
};
export default views;
